module.exports = ".deo-icon.deo-pdf {\n  color: #e74c3c;\n  margin-right: 5px; }\n\n.deo-table td {\n  vertical-align: middle; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/documents/document-list/document-list.component.scss
// module id = ./src/app/documents/document-list/document-list.component.scss
// module chunks = main